// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ContractController = function ($rootScope, $scope, $routeParams, $modal, $http, $location, $locale, Contract, ProductInfo, 
                                   ComponentSubscriptionByContract, ComponentUsage, ContractSelfServiceToken, SharedParameters, 
                                   gettextCatalog, gettext, DiscountSubscriptionByContract, LedgerEntryByContract, 
                                   ContractRatedItems, RatedItems, PrepaidCard, CustomFieldSettings, ContractInterimBill, 
                                   BillingSettings, PaymentEscalationReset, EscalationCheckSuspend, LedgerUtils, ContractNotesByContract, 
                                   babelFilter, LedgerEscalation, ContractChange, Features, PUtill, TimeGranularity, Component, 
                                   salesEntitiesService, ContractPauseService, DatepickerUtils) {
    
    $scope.hasCurrentOrFuturePauses = false;

    if ($location.url().toLowerCase().indexOf('embedded') > -1) {
        $rootScope.embeddedContractId = $routeParams.contractId;
    } else {
        $rootScope.embeddedContractId = undefined;
    }

    const paymentProviderRole = Object.freeze({
        "BlackLabel": "BlackLabel",
        "OnAccount": "OnAccount"
    });

    const paymentProvider = Object.freeze({
        "InvoicePayment": "InvoicePayment",
        "SwanOnAccount": "SwanOnAccount",
        "PayOne": "PayOne"
    });

    const paymentTermAction = Object.freeze({
        "Edit": "Edit",
        "Save": "Save",
        "Cancel": "Cancel"
    });

    const features = Object.freeze({
        "Atriga": "Atriga",
        "LegacyIap": "LegacyIap",
    });

    const entitiesNumberPerPage = 20;

    $scope.skipMainLoading = false;
    $scope.format = $locale.DATETIME_FORMATS.mediumDate;
    $scope.componentService = Component;

    $scope.componentSubscriptionsStatusFilter = null;
    $scope.componentSubscriptionCustomFields = {};    

    $scope.discountSubscriptionsStatusFilter = null;
    $scope.discountSubscriptionsCustomFieldFilter = {};


    $scope.meteredUsageStatusFilter = null;
    $scope.meteredUsageCustomFieldFilter = {};

    function runProcess(){
        $scope.skipMainLoading = true;
    }

    function finishProcess(){
        $scope.skipMainLoading = false;
    }

    var notification = SharedParameters.getValue('NotifyContract');
    if (notification) {
        SharedParameters.setValue('NotifyContract', null);
        $scope.notify(notification.messageType, notification.message);
        window.setTimeout(function () {
            $scope.$apply(function () {
                $scope.messages.splice(0, 1);
            });
        }, 5000);
    }
  
    $scope.billingSettings = BillingSettings.get({}, function () {
        $scope.isThresholdBillingDisabled = !$scope.billingSettings.ThresholdBilling.Enabled;
    });

    function compareComponentsByName(a, b) {
        //compare translated text with babelFilter prevent cody duplication
        var aText = babelFilter(a.Name).toLowerCase();
        var bText = babelFilter(b.Name).toLowerCase();
        if (aText < bText)
            return -1;
        if (aText > bText)
            return 1;
        return 0;
    }

    $scope.getPriceListItem = function (componentId) {
        return $scope.priceList?.Items?.find(x => x.ProductId === componentId) || $scope.priceList?.ParentItems?.find(x => x.ProductId === componentId);
    }

    $scope.features = Features.features;

    $scope.getDateTranslation = PUtill.getDateTranslation;

    $scope.isAvailableByFeature = function(featureName) {
        var value = $scope.features[featureName];
        return !!value;
    }

    function loadContract() {
        clearContractDetails();
        $scope.contract = Contract.get({contractId: $routeParams.contractId}, function () {
            $scope.planVariant = $scope.productInfo.PlanVariantById($scope.contract.PlanVariantId);
            $scope.plan = $scope.productInfo.PlanById($scope.contract.PlanId);
            $scope.planGroup = $scope.productInfo.PlanGroupById($scope.contract.PlanGroupId);
            $scope.priceList = $scope.productInfo.PriceListById($scope.contract.PriceListId);
            $scope.components = $scope.productInfo.ComponentsByPlanGroupId($scope.contract.PlanGroupId, compareComponentsByName);
            $scope.isAnnulled = $scope.contract.LifecycleStatus === "Annulled";
            $scope.isEnded = $scope.contract.LifecycleStatus === "Ended";
            $scope.discounts = $scope.productInfo.DiscountsByPlanGroupId($scope.contract.PlanGroupId);
            $scope.isRefundSupported = $scope.contract.PaymentProviderSupportRefunds;
            $scope.reversedPhases = $scope.contract.Phases.slice(0).reverse();
            $scope.isAdditionalFieldsTabVisible = $scope.contract.PaymentBearer !== undefined &&
                $scope.contract.PaymentBearer.Type === 'BankAccount' || $scope.contract.LifecycleStatus === 'InTrial';
            $scope.isDayTimeGranularity = $scope.planGroup.TimeGranularity === TimeGranularity.Day;
            // $scope.paymentProviderSettings = PaymentProviderSettings.get({paymentProvider: $scope.contract.PaymentProvider});
            //N.C. hotfix solution from IT-8203
            $scope.isPayExInvoiceServicePSP = $scope.contract.PaymentProvider === "PayExInvoiceService";
            $scope.hasCurrentOrFuturePauses = $scope.contract && $scope.contract.CurrentOrNextPause;

            if ($scope.isAvailableByFeature(features.Atriga)) {
                loadLedgerEscalation();
            }
            
            initializeIndividualTermOfPayment();
            initComponentSubscriptions();
            initMeteredUsages();
            initDiscountSubscriptions();            
            initSalesEntity();
        });
        loadCustomFieldSettings();
        
    }

    function initSalesEntity() {
        salesEntitiesService.query({}, function (response) {
            $scope.salesEntities = response;
            $scope.salesEntity = response.find(function (el) {
                return el.Id == $scope.contract.SalesEntityId;
            });
            
            if ($scope.salesEntity.IsDefault) {
                let defaultSuffix = " (" + gettextCatalog.getString(gettext('default')) + ")";
                $scope.salesEntity.InternalName += defaultSuffix;
            }
        });
    }

    function initializeIndividualTermOfPayment() {
        if ($scope.contract.PaymentProviderRole !== null && $scope.contract.PaymentProvider !== null) {
            var isBlackLabelInvoicePayment = $scope.contract.PaymentProviderRole === paymentProviderRole.BlackLabel && $scope.contract.PaymentProvider === paymentProvider.InvoicePayment;
            var isBlackLabelSwanOnAccount = $scope.contract.PaymentProviderRole === paymentProviderRole.BlackLabel && $scope.contract.PaymentProvider === paymentProvider.SwanOnAccount;
            $scope.isOnAccountPayOne = $scope.contract.PaymentProviderRole === paymentProviderRole.OnAccount && $scope.contract.PaymentProvider === paymentProvider.PayOne;
            $scope.isOnAccountPayment = isBlackLabelInvoicePayment || $scope.isOnAccountPayOne || isBlackLabelSwanOnAccount;
        }
        $scope.paymentTermInEditMode = false;
        setNewPaymentTermDefault();
        setPaymentTermSwitchDefault();
    }

    function clearContractDetails() {
        $scope.ledgerEntries = null;
        $scope.ratedItems = null;
        $scope.componentSubscriptions = null;
        $scope.meteredUsage = null;
        $scope.customFieldSettings = null;
        $scope.meteredUsageCustomFieldSettings = null;
        $scope.componentSubscriptionCustomFieldSettings = null;
        $scope.discountSubscriptionCustomFieldSettings = null;
        $scope.isAdditionalFieldsTabVisible = null;
        $scope.ledgerEscalation = null;
    }

    function loadLedgerEscalation() {
        runProcess();
        $rootScope.loadData('ledgerEscalation', function (promise) {
            return LedgerEscalation.query({ contractId: $scope.contract.Id },
                function (value) {
                    promise.resolve(value);
                },
                function (value) {
                    console.log("Ledger Escalation get error");
                    promise.reject(value);
                });
        }).then(function (res) {
            $scope.ledgerEscalation = res;
            finishProcess();
        }, function () { finishProcess(); });
    }

    $scope.loadLedgerEntries = function () {
        $scope.ledgerEntries = $scope.paginator(function (options, callback) {
            return LedgerEntryByContract.query(options, function() {
                callback();
                LedgerUtils.populateAdditionalDetails($scope.ledgerEntries.items);
                $scope.$digest();
            });
        }, { contractId: $scope.contract.Id }, entitiesNumberPerPage);
    };

    $scope.loadComponentSubscriptions = function () {
        if (!("contractId" in $routeParams))//hack to avoid error when the page changes while a modal dialog is visible
            return;

        let queryOptions = {
            contractId: $scope.contract.Id,
            status: $scope.componentSubscriptionsStatusFilter
        };

        if ($scope.componentSubscriptionCustomFields?.key !== undefined && $scope.componentSubscriptionCustomFields?.key !== '') {
            queryOptions[`CustomFields.${$scope.componentSubscriptionCustomFields.key}`] = $scope.componentSubscriptionCustomFields.value ?? '';
        }


        $scope.componentSubscriptions = $scope.paginator(function (options, callback) {
            return ComponentSubscriptionByContract.query(options, function () {
                callback();
            });
        }, queryOptions, entitiesNumberPerPage);
    };

    $scope.loadMeteredUsages = function () {
        let queryOptions = {
            contractId: $scope.contract.Id
        };
        
        if ($scope.meteredUsageCustomFieldFilter?.key !== undefined && $scope.meteredUsageCustomFieldFilter?.key !== '') {
            queryOptions[`CustomFields.${$scope.meteredUsageCustomFieldFilter.key}`] = $scope.meteredUsageCustomFieldFilter.value ?? '' ;
        }
        $scope.meteredUsage = $scope.paginator(function (options, callback) {
            return ComponentUsage.query(options, function () {
                callback();
            });
        }, queryOptions, entitiesNumberPerPage);
    };

    $scope.loadDiscountSubscriptions = function () {
        let queryOptions = {
            contractId: $scope.contract.Id,
            status: $scope.discountSubscriptionsStatusFilter
        };

        if ($scope.discountSubscriptionsCustomFieldFilter?.key !== undefined && $scope.discountSubscriptionsCustomFieldFilter?.key !== '') {
            queryOptions[`CustomFields.${$scope.discountSubscriptionsCustomFieldFilter.key}`] = $scope.discountSubscriptionsCustomFieldFilter.value ?? '';
        }

        $scope.discountSubscriptions = $scope.paginator(function (options, callback) {
            return DiscountSubscriptionByContract.query(options, function () {
                callback();
            });
        }, queryOptions, entitiesNumberPerPage);
    };
    $scope.clearComponentSubscriptionCustomFieldsFilter = function () {
        $scope.componentSubscriptionCustomFields = {};
        $scope.loadComponentSubscriptions();
    }

    $scope.clearDiscountSubscriptionsCustomFieldsFilter = function () {
        $scope.discountSubscriptionsCustomFieldFilter = {};
        $scope.loadDiscountSubscriptions();
    }

    $scope.clearMeteredUsageCustomFieldsFilter = function () {
        $scope.meteredUsageCustomFieldFilter = {};
        $scope.loadMeteredUsages();
    }

    function loadNotes() {
        runProcess();
        $rootScope.loadData('notes', function (promise) {
            return ContractNotesByContract.get({ contractId: $routeParams.contractId },
                function(value) {
                    promise.resolve(value);
                },
                function(value) {
                    console.log("Notes get error");
                    promise.reject(value);
                });
        }).then(function (res) {
            $scope.contractNotes = res;
            finishProcess();
        }, function () { finishProcess(); });
    }

    $scope.loadRatedItems = function () {
        $scope.ratedItems = $scope.paginator(function (options, callback) {
            return ContractRatedItems.query(options, function () {
                callback();
            });
        }, { contractId: $scope.contract.Id }, entitiesNumberPerPage);
    };

    function loadPrepaidCards() {
        runProcess();
        $rootScope.loadData('prepaidCards', function (promise) {
            return PrepaidCard.query({ Id: $scope.contract.Id },
                function (value) {
                    promise.resolve(value);
                },
                function (value) {
                    promise.reject(value);
                });
        }).then(function (res) {
            $scope.prepaidCards = res;
                finishProcess();
            }, function () { finishProcess();});
    }
    
    function loadCustomFieldSettings() {
        if (!$scope.customFieldSettings)
            CustomFieldSettings.get({ customFieldType: 'Contract' }, function (data) {
                $scope.customFieldSettings = data.CustomFieldDescriptors;
            });            

        if (!$scope.componentSubscriptionCustomFieldSettings)
            CustomFieldSettings.get({customFieldType: 'ComponentSubscription'}, function (data) {
                $scope.componentSubscriptionCustomFieldSettings = data.CustomFieldDescriptors;
            });

        if (!$scope.meteredUsageCustomFieldSettings)
            CustomFieldSettings.get({ customFieldType: 'MeteredUsage' }, function (data) {
                $scope.meteredUsageCustomFieldSettings = data.CustomFieldDescriptors;
            });

        if (!$scope.discountSubscriptionCustomFieldSettings)
            CustomFieldSettings.get({ customFieldType: 'DiscountSubscription' }, function (data) {
                $scope.discountSubscriptionCustomFieldSettings = data.CustomFieldDescriptors;
            });
    }

    $scope.loadContractChanges = function () {
        $scope.contractChanges = $scope.paginator(function (options, callback) {
            return ContractChange.query(options, function () {
                callback();
            });
        }, { contractId: $scope.contract.Id}, entitiesNumberPerPage);
    };
    
    function initDiscountSubscriptions() {
        $scope.newDiscountSubscription = new DiscountSubscriptionByContract();
        $scope.newDiscountSubscription.StartDate=null;
    }

    function initComponentSubscriptions() {
        $scope.newComponentSubscription = new ComponentSubscriptionByContract();
        $scope.newComponentSubscription.Quantity = 1;
        $scope.newComponentSubscription.StartDate = null;
        $scope.newComponentSubscription.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    }

    function initMeteredUsages(){
        $scope.newMeteredUsage = new ComponentUsage();
        $scope.newMeteredUsage.DueDate = null;
        $scope.newMeteredUsage.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    }
    
    $scope.getDateToTimeAdjusted = function(date) {
        return Contract.getDateToPhaseStartTimeAdjusted($scope.contract, date);
    };
    
    function loadContractDetails() {
        switch($scope.selectedTab) {
            case 'history': {
                if ($scope.isAvailableByFeature('Atriga'))
                    loadLedgerEscalation(); 
                break;
            }
            case 'rateditems' : {
                $scope.loadRatedItems();
                break;
            }
            case 'details' : {
                break;
            }
            case 'ledger' : {
                $scope.loadLedgerEntries();
                break;
            }
            case 'components' : {
                $scope.loadComponentSubscriptions();
                break;
            }
            case 'usage' : {
                $scope.loadMeteredUsages();
                break;
            }
            case 'discounts': {
                $scope.loadDiscountSubscriptions();
                break;
            }
            case 'notes': {
                loadNotes();
                break;
            }
            case 'prepaidCards': {
                loadPrepaidCards();
                break;
            }
            case 'changes' :{
                $scope.loadContractChanges();
                break;
            }
        }
    }

    $scope.$watch('selectedTab', function () {
        loadContractDetails();
    }, true);
    
    ProductInfo.getProductInfoForContract($routeParams.contractId, true, function(productInfo, error) {
        if (error) {
            console.error("Failed to fetch product info:", error);
            return;
        }
        if (productInfo) {
            $scope.productInfo = productInfo;

            loadContract();
        }
    });

    $scope.isRecurringItemInactive = function (recurringItem) {
        return recurringItem.EndDate &&
               (recurringItem.EndDate === recurringItem.StartDate || !$rootScope.isInFuture(recurringItem.EndDate))
    }
    
    $scope.IsNonMetered = function (elem) {
        return elem.ComponentType !== 'Metered';
    };

    $scope.saveNewComponentSubscription = function () {
        if (!$rootScope.isValid($scope.newComponentSubscriptionForm))
            return;
        
        $scope.newComponentSubscription.ProductOverride = SetupProductOverride($scope.newComponentSubscription.ProductOverride);
        $scope.newComponentSubscription.$save({contractId: $scope.contract.Id},
            function () {
                $scope.loadComponentSubscriptions();
                initComponentSubscriptions();
                $scope.notify("success", gettextCatalog.getString(gettext("New component subscription added successfully")));
            }
        );
    };

    $scope.addNewDiscountSubscription = function () {
        if (!$rootScope.isValid($scope.newDiscountSubscriptionForm))
            return;

        $scope.newDiscountSubscriptionForm.StartDate = DatepickerUtils.backToBrowserTimezone($scope.newDiscountSubscriptionForm.StartDate);
        $scope.yesCancel(gettextCatalog.getString(gettext('Add Discount Subscription')), gettextCatalog.getString(gettext('Adding a discount in an already billed period might result in a credit note and a new invoice for already billed items.')),
            function () {
                $scope.newDiscountSubscription.$save({ contractId: $scope.contract.Id },
                    function () {
                        $scope.notify("success",
                            gettextCatalog.getString(gettext("New discount subscription added successfully")));
                        $scope.loadDiscounts();
                    }
                );
            },
            function () {
            });
    };

    $scope.updateDateTime = function (dateTime) {
        ContractUpdateDateTime.update({ contractId: $routeParams.contractId, datetime: dateTime },
            function() {
                $scope.notifySuccess();
            });
    };

    $scope.saveMeteredUsage = function () {
        if (!$rootScope.isValid($scope.newMeteredUsage))
            return;
        if ($scope.newMeteredUsage.DueDate < $scope.contract.StartDate)
            $scope.newMeteredUsage.DueDate = $scope.contract.StartDate;
        $scope.newMeteredUsage.ProductOverride = SetupProductOverride($scope.newMeteredUsage.ProductOverride);
        runProcess();
        $rootScope.loadData('usage', function (promise) {
            return $scope.newMeteredUsage.$save({ contractId: $scope.contract.Id },
                function(value) { promise.resolve(value); },
                function(value) { promise.reject(value); });
        }).then(function(){
            $scope.loadMeteredUsages();
            initMeteredUsages();
            $scope.notify("success", gettextCatalog.getString(gettext("Metered usage added successfully")));
        },function() {
            finishProcess();
        });
    };

    $scope.deleteMeteredUsage = function(usage) {
        runProcess();
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Metered Usage')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function() {
                $rootScope.loadData('usage',
                    function(promise) {
                        return ComponentUsage.remove({ contractId: usage.ContractId, usageId: usage.Id },
                            function(value) { promise.resolve(value); },
                            function(value) { promise.reject(value); });
                    }).then(function() {
                        $scope.notify("success",
                            gettextCatalog.getString(gettext("Metered usage deleted successfully.")));
                        $scope.loadMeteredUsages();
                    },
                    function() {
                        finishProcess();
                        $scope.notify("error",
                            gettextCatalog.getString(gettext("Metered usage could not be deleted.")));
                    });
            },
            function() {
                finishProcess();
            });
    };
    
    $scope.deleteRatedItem = function(item) {
        runProcess();
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Rated Item')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function() {
                $rootScope.loadData('usage',
                    function(promise) {
                        return RatedItems.remove({ ratedItemId: item.Id },
                            function(value) { promise.resolve(value); },
                            function(value) { promise.reject(value); });
                    }).then(function() {
                        $scope.notify("success", gettextCatalog.getString(gettext("Rated Item deleted successfully.")));
                        $scope.loadRatedItems();
                    },
                    function() {
                        finishProcess();
                        $scope.notify("error", gettextCatalog.getString(gettext("Rated Item could not be deleted.")));
                    });
            },
            function() {
                finishProcess();
            });
    };
    
    $scope.onNewTrialEndSelectedAndConfirmed = function(newDate){
        $scope.update(newDate);
    };
    
    $scope.update = function (trialEnd) {        
        if ($scope.contract.PaymentBearer) {
            if ($scope.contract.PaymentBearer.MandateReference)
                $scope.contract.MandateReference = $scope.contract.PaymentBearer.MandateReference;
            if ($scope.contract.PaymentBearer.MandateSignatureDate)
                $scope.contract.MandateSignatureDate = DatepickerUtils.backToBrowserTimezone($scope.contract.PaymentBearer.MandateSignatureDate);
        }
        $scope.contract.$update({contractId: $routeParams.contractId}, function () {
            if (trialEnd) {                
                var t = moment($scope.contract.CurrentPhase.StartDate);
                var trialEndM=moment(trialEnd);
                
                var addSecond=0;
                if (t.diff(trialEndM, 'days')==0 && $scope.planGroup.TimeGranularity !== TimeGranularity.Day){
                    addSecond=1;
                }
                
                trialEnd = trialEndM.hours(t.hours()).minutes(t.minutes()).seconds(t.seconds()+addSecond);
                $http({
                    method: "PUT", url: "/api/v1/contracts/" + $routeParams.contractId + "/trialEnd", params: null,
                    data: {TrialEndDate: trialEnd}, headers: {}, cache: false
                }).then(function () {
                    $scope.notifySuccess();
                    loadContract();
                });
            }
            else {
                //custom fields, mandate
                $scope.notifySuccess();
                loadContract();
            }
        });
    };

    $scope.canEditSubscription = function () {
        return true;
    };

    $scope.editSubscription = function (componentSubscription) {
        if (!$scope.canEditSubscription(componentSubscription))
            return;

        var modalInstance = $modal.open({
            templateUrl: 'partials/componentSubscription-edit.html' + $scope.linkVersion,
            controller: ComponentSubscriptionEditController,
            windowClass: "fade in",
            resolve: {
                componentSubscriptionId: function () {
                    return componentSubscription.Id;
                },
                contract: function () {
                    return $scope.contract;
                }
            }
        });
        modalInstance.result.then($scope.loadComponentSubscriptions);
    };

    $scope.previewCustomFields = function (subscription, customFieldsSettings) {
        $modal.open({
            templateUrl: 'partials/contract-subscription-custom-fields.html' + $scope.linkVersion,
            controller: CustomFieldsDialogController,
            windowClass: "fade in",
            resolve: {
                customFieldSettings: function () {
                    return customFieldsSettings;
                },
                customFields: function () {
                    return subscription.CustomFields;
                }
            }
        });
    };

    $scope.canReplaceSubscription = function (componentSubscription) {
        // HACK: this method is invoked by the UI, and we don't have any guarantees that $scope.productInfo is already loaded yet, so we simply ignore the component type if the productInfo hasn't loaded yet.
        return !componentSubscription.EndDate && (!$scope.productInfo.ComponentById || $scope.productInfo.ComponentById(componentSubscription.ComponentId).ComponentType !== 'OnOff');
    };

    $scope.replaceSubscription = function (componentSubscription) {
        if (!$scope.canReplaceSubscription(componentSubscription))
            return;

        var modalInstance = $modal.open({
            templateUrl: 'partials/componentSubscription-replace.html' + $scope.linkVersion,
            controller: ComponentSubscriptionReplaceController,
            windowClass: "fade in",
            resolve: {
                componentSubscriptionId: function () {
                    return componentSubscription.Id;
                },
                contract: function () {
                    return $scope.contract;
                }                
            }
        });
        modalInstance.result.then($scope.loadComponentSubscriptions);
    };

    $scope.canEndSubscription = function (componentSubscription) {
        return componentSubscription.StartDate !== componentSubscription.EndDate;
    };

    $scope.canEndDiscountSubscription = function (discountSubscription) {
        return discountSubscription.StartDate !== discountSubscription.EndDate;
    };
        
    $scope.endSubscription = function (componentSubscription) {
        if (!$scope.canEndSubscription(componentSubscription))
            return;

        var modalInstance = $modal.open({
            templateUrl: 'partials/componentSubscription-end.html' + $scope.linkVersion,
            controller: ComponentSubscriptionEditController,
            windowClass: "fade in",
            resolve: {
                componentSubscriptionId: function () {
                    return componentSubscription.Id;
                },
                contract: function () {
                    return $scope.contract;
                }
            }
        });
        modalInstance.result.then($scope.loadComponentSubscriptions);
    };
    
    $scope.endDiscountSubscription = function (discountSubscription) {
        if (!$scope.canEndDiscountSubscription(discountSubscription))
            return;
        var modalInstance = $modal.open({
            templateUrl: 'partials/discountSubscription-end.html' + $scope.linkVersion,
            controller: DiscountSubscriptionEditController,
            windowClass: "fade in",
            resolve: {
                discountSubscriptionId: function () {
                    return discountSubscription.Id;
                },
                contract: function () {
                    return $scope.contract;
                }
            }
        });
        modalInstance.result.then($scope.loadDiscountSubscriptions);
    };

    $scope.getToken = function () {
        var token = ContractSelfServiceToken.get({contractId: $routeParams.contractId}, function () {
            $modal.open({
                templateUrl: 'partials/token-dialog.html' + $scope.linkVersion,
                controller: TokenDialogController,
                windowClass: "fade in",
                resolve: {
                    token: function () {
                        return token;
                    }
                }
            });
        });
    };

    $scope.continuePayments = function () {
        if (!$scope.contract.RecurringPaymentsPaused)
            return;
        $http({
            method: "POST",
            url: "/api/v1/Contracts/" + $routeParams.contractId + "/continuePayments",
            params: null,
            data: {},
            headers: {},
            cache: false
        }).then(function (response) {
            if (response.data.Succeeded === true)
                $scope.contract.RecurringPaymentsPaused = false;
        });
    };

    $scope.pausePayments = function () {
        if ($scope.contract.RecurringPaymentsPaused)
            return;

        var pausePayments = function(cancelScheduledPayments) {
            $http({
                    method: "POST",
                    url: "/api/v1/Contracts/" + $routeParams.contractId + "/pausePayments",
                    params: {
                        'cancelScheduledPayments': cancelScheduledPayments
                    },
                    headers: {},
                    cache: false
                })
                .then(function(response) {
                    if (response.data.Succeeded === true)
                        $scope.contract.RecurringPaymentsPaused = true;

                    $scope.skipMainLoading = false;
                });
        };

        var modalInstance = $modal.open({
                templateUrl: 'partials/cancel-scheduled-transactions-dialog.html' + $scope.linkVersion,
                controller: CancelScheduledTransactionsDialogController,
                windowClass: 'fade in',
                resolve: {}
            });

        $scope.skipMainLoading = true;

        modalInstance.result.then(
            function (cancelScheduledPayments) {
                return pausePayments(cancelScheduledPayments);
            },
            function () {
                $scope.skipMainLoading = false;
            });
    };

    $scope.suspendEscalationCheck = function () {
        if ($scope.contract.EscalationSuspended)
            return;
        $scope.yesNoCancel(gettextCatalog.getString(gettext('Switch off payment escalation')), gettextCatalog.getString(gettext('Do you also want to reset the escalation status?')),
            function (resetComment) {
                PaymentEscalationReset.save($routeParams.contractId, {comment: resetComment}).then(function(response) {
                    $scope.contract.EscalationSuspended = response.data.EscalationSuspended;
                    $scope.contract.CurrentDunning = null;
                });
            },
            function () {
                EscalationCheckSuspend.save({ contractId: $routeParams.contractId }, {},
                    function (data) {
                        $scope.contract.EscalationSuspended = data.EscalationSuspended;
                    });
            }, null, null, true);
    };

    // TODO: Ensure there's really no RESTful way to do this, this is RPC!
    $scope.resumeEscalationCheck = function () {
        if (!$scope.contract.EscalationSuspended)
            return;
        $http({
            method: "POST",
            url: "/api/v1/contracts/" + $routeParams.contractId + "/resumeEscalationCheck",
            params: null,
            data: {},
            headers: {},
            cache: false
        }).then(function (response) {
            $scope.contract.EscalationSuspended = response.data.EscalationSuspended;
        });
    };

    $scope.setBillingSuspended = function (status) {
        if ($scope.contract.BillingSuspended === status){
            return;
        }
        
        $http({
            method: "PUT",
            url: "/api/v1/contracts/" + $routeParams.contractId + "/billingSuspended",
            params: null,
            data: status.toString(),
            headers: {},
            cache: false
        }).then(function () {
            $scope.contract.BillingSuspended = status;
        });
    };

    var upgrade = function () {
        var newContractInterimBill = new ContractInterimBill();
        newContractInterimBill.$save({ contractId: $routeParams.contractId }, function () {
            $scope.notifyCustomSuccess(gettextCatalog.getString(gettext("Started billing")));
        });
    };

    $scope.interimBilling = function () {
        $scope.yesCancel(gettextCatalog.getString(gettext("Execute interim billing")),
            gettextCatalog.getString(gettext("Do you want to execute an interim billing now?")),
            function () {
                upgrade();
            },
            function () {
            }
        );
    };

    $scope.setThresholdBillingDisabled = function (status) {
        if ($scope.contract.ThresholdBillingDisabled === status){
            return;
        }
        
        $http({
            method: "PUT",
            url: "/api/v1/contracts/" + $routeParams.contractId + "/thresholdBillingDisabled",
            params: null,
            data: status.toString(),
            headers: {},
            cache: false
        }).then(function () {
            $scope.contract.ThresholdBillingDisabled = status;
        });
    };

    $scope.getShippingAddressFormatForContract = function () {
        var shippingAddress = $scope.contract?.AdditionalAddresses?.find(x => x.Id && x.Id === $scope.contract.ShippingAddressId);
        if(!shippingAddress)
            return "-";

        const array = [];
        if (shippingAddress.Street) {
            var text = shippingAddress.Street;
            if (shippingAddress.HouseNumber) {
                text += " " + shippingAddress.HouseNumber;
            }
            array.push(text);
        }
        if (shippingAddress.PostalCode) array.push(shippingAddress.PostalCode);
        if (shippingAddress.City) array.push(shippingAddress.City);
        if (shippingAddress.Country) array.push(shippingAddress.Country);
        return array.join(", ");
    }

    $scope.addContractNote = function() {
        var modalInstance = $modal.open({
            templateUrl: 'partials/contract-note-dialog.html' + $scope.linkVersion,
            controller: ContractNoteDetailsDialogController,
            windowClass: "fade in",
            resolve: {
                contractNoteId: function() {
                    return null;
                },
                contract: function() {
                    return $scope.contract;
                }
            }
        });
        modalInstance.result.then(loadNotes);
    };

    $scope.editContractNote = function(noteId) {
        var modalInstance = $modal.open({
            templateUrl: 'partials/contract-note-dialog.html' + $scope.linkVersion,
            controller: ContractNoteDetailsDialogController,
            windowClass: "fade in",
            resolve: {
                contractNoteId: function() {
                    return noteId;
                },
                contract: function() {
                    return $scope.contract;
                }
            }
        });
        modalInstance.result.then(loadNotes);
    };

    $scope.deleteContractNote = function(noteId) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Contract Note')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function() {
                ContractNotesByContract.remove({ contractId: $routeParams.contractId, noteId: noteId },
                    function() {
                        $scope.notify("success",
                            gettextCatalog.getString(gettext("Contract Note deleted successfully.")));
                        loadNotes();
                    },
                    function() {
                        $scope.notify("error",
                            gettextCatalog.getString(gettext("Contract Note could not be deleted.")));
                    });
            });
    };

    $scope.hasPermissionToEditContractNote = function(contractNote) {
        if ($scope.adminOrInRole([])) {
            return true;
        }
        return contractNote.IsAuthoredByMe;
    };

    $scope.getLastUpdate = function(contractNote) {
        return (contractNote.ChangedAt ? contractNote.ChangedAt : contractNote.CreatedAt);
    };
    
    $scope.contractNotes = [];

    $scope.setPaymentTerm = function (value) {
        $scope.paymentTermSwitchOn = value;

        if (value === true) {
            $scope.actionOnPaymentTerm(paymentTermAction.Edit);
        } else {

            if ($scope.contract.OnAccountDueAfter !== undefined) {
                $scope.putIndividualTermOfPayments(null);
            }
            $scope.paymentTermInEditMode = false; 
        }
    };
    
    $scope.actionOnPaymentTerm = function (option) {
        switch (option) {
            case paymentTermAction.Save:
                if ($scope.newPaymentTerm.Quantity === undefined || $scope.newPaymentTerm.Quantity < 0) {   
                    return;
                }
                $scope.paymentTermInEditMode = false; 
                $scope.putIndividualTermOfPayments($scope.newPaymentTerm);
                setNewPaymentTermDefault();
                setPaymentTermSwitchDefault();
                break;
            case paymentTermAction.Cancel:
                setNewPaymentTermDefault();
                setPaymentTermSwitchDefault();
                $scope.paymentTermInEditMode = false;
                break;
            case paymentTermAction.Edit:
                $scope.paymentTermInEditMode = true; 
                $scope.newPaymentTerm = $scope.contract.OnAccountDueAfter !== undefined ? angular.copy($scope.contract.OnAccountDueAfter) : { Quantity: 1, Unit: PUtill.PeriodUnitMappings.Day.key };
                break;
            default:
                return;
        }
    };

    function setNewPaymentTermDefault() {
        $scope.newPaymentTerm = { Quantity: 1, Unit: PUtill.PeriodUnitMappings.Day.key };
    }

    function setPaymentTermSwitchDefault() {
        $scope.paymentTermSwitchOn = $scope.contract.OnAccountDueAfter !== undefined ? true : false;
    }

    $scope.putIndividualTermOfPayments = function (termOfPayments) {
        $http({
            method: "PUT",
            url: "/api/v1/contracts/" + $routeParams.contractId + "/IndividualTermOfPayments",
            params: null,
            data: termOfPayments,
            headers: {},
            cache: false
        }).then(function (response) {
            if (termOfPayments === null) {
                delete $scope.contract.OnAccountDueAfter;
            } else {
                $scope.contract.OnAccountDueAfter = response.data;
            }
            setNewPaymentTermDefault();
            setPaymentTermSwitchDefault();
        });
    };

    $scope.hasIapRestrictions = function() {
        if ($scope.isAvailableByFeature(features.LegacyIap)) {
            return false;
        } else {
            if ($scope.contract && $scope.contract.ExternalSubscription) {
                return true;
            }
        }

        return false;
    };
    
    $scope.wasWrittenOff = function () {
        return $scope.contract && $scope.contract.WriteOff; 
    };
    
    $scope.canPayReceivables = function() {
        return $scope.contract && !$scope.contract.CustomerIsLocked && !$scope.contract.WriteOff &&
            !$scope.contract.DeletionRequestedAt && !$scope.hasIapRestrictions();
    }
    
    $scope.isContractLockedOrDeletionRequested = function() {
        return $scope.contract && ($scope.contract.CustomerIsLocked || $scope.contract.DeletionRequestedAt);
    }

    $scope.hasCurrentPause = function () {

        return $scope.contract && $scope.contract.CurrentPause;
    }

    $scope.anyPause = function () {
        return $scope.contract && $scope.contract.Pauses && $scope.contract.Pauses.length > 0;
    }
    
    $scope.canBeCancelled = function (pause) {
        var now = new Date();
        var startDate = new Date(pause.StartDate);
        return pause.StartDate !== pause.EndDate && startDate > now;
    }

    $scope.cancelPause = function (pause) {

        $scope.yesCancel(
            gettextCatalog.getString(gettext('Cancel pause')),
            gettextCatalog.getString(gettext('Do you want to cancel the pause?')),
            function () {
                ContractPauseService.resume($routeParams.contractId, pause.Id, pause.StartDate).then(function () {
                    window.location.reload();
                });
            }
        )
    }

    $scope.ResetComponentSubscriptionProductOverride = function () {
        $scope.newComponentSubscription.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    }

    $scope.ResetMeteredUsageProductOverride = function () {
        $scope.newMeteredUsage.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    }

    $scope.GetComponentName = function (baseComponent, newComponent) {
        const isOverrideNameExist = baseComponent.Id && 
            newComponent &&
            baseComponent.Id === newComponent.ComponentId &&
            newComponent.ProductOverride && newComponent.ProductOverride.Name &&
            newComponent.ProductOverride.Name !== "";
        const extIdPrefix= baseComponent.ExternalId?`${baseComponent.ExternalId} `:"";
        if (isOverrideNameExist) {
            return `${extIdPrefix}${newComponent.ProductOverride.Name} - ${babelFilter(baseComponent.Name)}`;
        }
        return `${extIdPrefix}${babelFilter(baseComponent.Name)}`;
    }

    $scope.AssignShippingAddress = function () {
        $modal.open({
            templateUrl: 'partials/assign-shipping-address.html' + $scope.linkVersion,
            controller: AssignShippingAddressController,
            windowClass: "fade in",
            resolve: {
                CustomerId: function () {
                    return $scope.contract.CustomerId;
                },
                Contract: function () {
                    return $scope.contract;
                },
                AdditionalAddresses: function () {
                    return $scope.contract.AdditionalAddresses;
                },
                Modal: function () {
                    return $modal;
                }
            }
        });
    }

    const SetupProductOverride = function (productOverride) {
        if (productOverride.Name === "" &&
            productOverride.PricePerUnit === "" &&
            productOverride.Description === "") {
            productOverride = null;
        }
        if (productOverride && productOverride.Name === "") {
            delete productOverride.Name;
        }
        if (productOverride && productOverride.pricePerUnit === "") {
            delete  productOverride.PricePerUnit;
        }
        if (productOverride && productOverride.Description === "") {
            delete productOverride.Description;
        }
        return productOverride;
    }

    // ReSharper disable JsUnreachableCode
    // noinspection UnreachableCodeJS

    // to translate ContractLifecycleStatus
    gettext("Undefined");
    gettext("Draft");
    gettext("InOrderProcess");
    gettext("InTrial");
    gettext("TrialExpired");
    gettext("Active");
    gettext("Ended");
    gettext("TemporarilyInactive");
    gettext("Annulled");
    gettext("Locked");
    gettext("Cancelled");
    
    // to translate ContractPhaseType
    gettext("Inactive");
    gettext("Normal");
    gettext("Trial");
    
    // to translate ContractChangeType
    gettext("Signup");
    gettext("Upgrade");
    gettext("EndContract");
    gettext("Annulation");
    gettext("ExternalSubscriptionSync");

    // to translate LedgerEntryType
    gettext("Receivable");
    gettext("Payment");
    gettext("Refund");
    gettext("Adjustment");
    gettext("Chargeback");
    gettext("Cancelation");
    gettext("PrepaidCard");

    // to translate PaymentTransactionStatusValue
    gettext("Confirmed");
    gettext("Unconfirmed");
    
    if ($location.absUrl().includes("contracts/") && $routeParams.contractId != null) {
        const analyticData = {
            url: $location.absUrl(),
            path: $location.path(),
            userAgent: window.navigator.userAgent,
        };
    }
};
ContractController.$inject = ['$rootScope', '$scope', '$routeParams', '$uibModal', '$http', '$location', '$locale', 
    'Contract', 'ProductInfo', 'ComponentSubscriptionByContract', 'ComponentUsage', 'ContractSelfServiceToken', 
    'SharedParameters', 'gettextCatalog', 'gettext', 'DiscountSubscriptionByContract', 'LedgerEntryByContract', 
    'ContractRatedItems', 'RatedItems', 'PrepaidCard', 'CustomFieldSettings', 'ContractInterimBill', 'BillingSettings', 
    'PaymentEscalationReset', 'EscalationCheckSuspend', 'LedgerUtils', 'ContractNotesByContract', 'babelFilter', 
    'LedgerEscalation', 'ContractChange', 'Features', 'PUtill', 'TimeGranularity', 'Component', 'SalesEntities',
    'ContractPauseService', 'DatepickerUtils'];
